@if (loading$ | async) {
  <div class="spinner-container">
    <span class="loading loading-spinner loading-md"></span>
  </div>
}
